export default __webpack_public_path__ + "static/media/coins_light.9fbc93a8.png";